import Routes from '@/constants/routes'
import Roles from '@/constants/roles'
import {
    Companies,
    CompanyUsers,
    CreateCompany,
    CreateDeal,
    CreateUser,
    CreateVehicle,
    Dashboard,
    Deal,
    EditVehicle,
    Inventory,
    Login,
    Message,
    PasswordEmail,
    PasswordReset,
    Profile,
    Settings,
    User,
    Vehicle,
    VehicleShortlist,
    ViewCompany,
    ViewUser,
    ViewVehicle,
    ViewVehicleShare,
    CustomerEnquiry
} from "@/pages";

export default [
    {
        path: '/',
        redirect: {
            name: Routes.dashboard
        },
        meta: {
            auth: true
        }
    },
    {
        path: '/dashboard',
        name: Routes.dashboard,
        component: Dashboard,
        meta: {
            auth: true
        }
    },
    {
        path: '/inventory',
        name: Routes.inventory,
        component: Inventory,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager,
            ]
        }
    },
    {
        path: '/login',
        name: Routes.login,
        component: Login,
        meta: {
            guest: true
        }
    },
    {
        path: '/password/email',
        name: Routes.password_email,
        component: PasswordEmail,
        meta: {
            guest: true
        }
    },
    {
        path: '/password/reset/:token',
        name: Routes.password_reset,
        component: PasswordReset,
        meta: {
            guest: true
        }
    },
    {
        path: '/deal',
        name: Routes.deal,
        component: Deal,
        meta: {
            auth: true,
            roles: [
                Roles.sales_person,
                Roles.dealer_principle,
                Roles.sales_manager
            ]
        }
    },
    {
        path: '/vehicle',
        name: Routes.vehicle,
        component: Vehicle,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager,
                Roles.sales_person
            ]
        }
    },
    {
        path: '/vehicle/:id',
        name: Routes.view_vehicle,
        component: ViewVehicle,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager,
                Roles.sales_person
            ]
        }
    },
    {
        path: '/vehicle/:id/edit',
        name: Routes.edit_vehicle,
        component: EditVehicle,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager,
            ]
        }
    },
    {
        path: '/vehicle/:vehicle_id/create-deal',
        name: Routes.create_deal,
        component: CreateDeal,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager,
                Roles.sales_person,
            ]
        }
    },
    {
        path: '/create-vehicle',
        name: Routes.create_vehicle,
        component: CreateVehicle,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager
            ]
        }
    },
    {
        path: '/vehicle-shortlist',
        name: Routes.vehicle_shortlist,
        component: VehicleShortlist,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager,
                Roles.sales_person
            ]
        }
    },
    {
        path: '/message/:deal_id/thread/:customer_id',
        name: Routes.message,
        component: Message,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager,
                Roles.sales_person
            ]
        },
    },
    {
        path: '/profile',
        name: Routes.profile,
        component: Profile,
        meta: {
            auth: true,
            roles: [
                Roles.admin,
                Roles.dealer_principle,
                Roles.sales_manager,
                Roles.sales_person
            ]
        }
    },
    {
        path: '/company',
        name: Routes.company,
        component: Companies,
        meta: {
            auth: true,
            roles: [
                Roles.admin
            ]
        }
    },
    {
        path: '/create-company',
        name: Routes.create_company,
        component: CreateCompany,
        meta: {
            auth: true,
            roles: [
                Roles.admin
            ]
        }
    },
    {
        path: '/company/:id',
        name: Routes.view_company,
        component: ViewCompany,
        meta: {
            auth: true,
            roles: [
                Roles.admin
            ]
        }
    },
    {
        path: '/company/:company_id/users',
        name: Routes.company_users,
        component: CompanyUsers,
        meta: {
            auth: true,
            roles: [
                Roles.admin
            ]
        }
    },
    {
        path: '/user',
        name: Routes.user,
        component: User,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle
            ]
        }
    },
    {
        path: '/create-user',
        name: Routes.create_user,
        component: CreateUser,
        meta: {
            auth: true,
            roles: [
                Roles.admin,
                Roles.dealer_principle
            ]
        }
    },
    {
        path: '/user/:id',
        name: Routes.view_user,
        component: ViewUser,
        meta: {
            auth: true,
            roles: [
                Roles.admin,
                Roles.dealer_principle
            ]
        }
    },
    {
        path: '/settings',
        name: Routes.settings,
        component: Settings,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager,
            ]
        }
    },
    {
        path: '/share/vehicle/:share_id',
        name: Routes.view_vehicle_share,
        component: ViewVehicleShare,
        meta: {
            auth: false,
        }
    },
    {
        path: '/customer-enquiries',
        name: Routes.customer_enquiry,
        component: CustomerEnquiry,
        meta: {
            auth: true,
            roles: [
                Roles.dealer_principle,
                Roles.sales_manager,
                Roles.sales_person
            ]
        }
    },
]
